import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { ChevronDown, ChevronUp } from '../../../Common/SvgIcon/CommonSvgIcons';
import MinMaxSlider from './Slider';
import { IoClose } from 'react-icons/io5';

const Container = styled.div`
  width: 430px;
`;

const Header = styled.div`
  color: var(--Body, #2a2929);
  font-family: Inter;
  font-weight: 600;
  font-size: 16px;
  text-transform: capitalize;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
`;

const Section = styled.div`
  margin-top: 10px;
`;

const CheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 10px;
  margin-bottom: 5px;
  font-family: Montserrat;
  font-weight: 400;
  font-size: 15px;
  input {
    accent-color: #2d8955;
  }
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 10px;
`;

const RedError = styled.div`
    font-size: 12px;
    text-align: center;
    color: red;
`;

const EngagementCountWrapper = styled.div`
  background-color: #2d8955;
  display: flex;
  gap: 8px;
  font-family: Inter;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  padding: 6px;
  align-items: center;
  width: 30px;
`;
const ButtonContainer = styled.button`
  border: none;
  background: none;
  padding: unset;
  padding-top: 2px;
`;
const EngagementFilter = ({
  title = 'Engagement',
  filterLabels = ['Likes', 'Replies', 'Reposts', 'Views'],
  onChange,
  resetTrigger,
  isOpen,
  onToggle,
  likeError='',
  commentError='',
  viewError='',
  setViewError,
  setCommentError,
  setLikeError
}) => {
  const getInitialFilters = () => {
    return Object.fromEntries(filterLabels.map((label) => [label, false]));
  };

  const getInitialSliders = () => {
    return Object.fromEntries(
      filterLabels.map((label) => [label, [0, 100000]])
    );
  };

  const [filters, setFilters] = useState(getInitialFilters);
  const [sliderValues, setSliderValues] = useState(getInitialSliders);

  useEffect(() => {
    if (onChange) {
      onChange({ filters, sliders: sliderValues });
    }
  }, [filters, sliderValues]);

  useEffect(() => {
    setFilters(getInitialFilters());
    setSliderValues(getInitialSliders());
  }, [resetTrigger]);

  const toggleFilter = (name) => {
    if(name == 'Likes'){
      setLikeError('')
    } 
    if(name == 'Comments'){
      setCommentError('')
    }
    if(name == 'Views'){
      setViewError('')
    }
    setFilters((prev) => {
      const newValue = !prev[name];
      if (!newValue) {
        setSliderValues((sliders) => ({
          ...sliders,
          [name]: [0, 100000],
        }));
      }
      return { ...prev, [name]: newValue };
    });
  };

  const handleSliderChange = (label, newValue) => {
    if(label == 'Likes'){
      setLikeError('')
    } 
    if(label == 'Comments'){
      setCommentError('')
    }
    if(label == 'Views'){
      setViewError('')
    }
    setSliderValues((prev) => ({
      ...prev,
      [label]: newValue,
    }));
  };

  return (
    <Container>
      <Header onClick={onToggle}>
        <div style={{color:(likeError != null && commentError != null && viewError != null) ? '' : 'red'}}>{title}</div>
        <div style={{ display: 'flex', gap: '20px' }}>
          {Object.values(filters).filter((val) => val)?.length > 0 && (
            <EngagementCountWrapper>
              <div>{Object.values(filters).filter((val) => val).length}</div>
              <ButtonContainer
                onClick={(e) => {
                  e.stopPropagation();
                  setFilters(getInitialFilters());
                  setSliderValues(getInitialSliders());
                }}
              >
                <IoClose color='#ffffff' />
              </ButtonContainer>
            </EngagementCountWrapper>
          )}
          <div>{isOpen ? ChevronUp : ChevronDown}</div>
        </div>
      </Header>

      {isOpen && (
        <Section>
          {filterLabels.map((label) => (
            <Wrapper key={label}>
              <CheckboxLabel>
                <input
                  type='checkbox'
                  checked={filters[label]}
                  onChange={() => toggleFilter(label)}
                />
                {label}
              </CheckboxLabel>
              {filters[label] && (
                <MinMaxSlider
                  label={label}
                  value={sliderValues[label]}
                  onChange={(val) => handleSliderChange(label, val)}
                  min={0}
                  max={100000}
                />
              )}
              {label == 'Likes' && likeError != '' && <RedError>{likeError}</RedError>}
              {label == 'Comments' && commentError != '' && <RedError>{commentError}</RedError> }
              {label == 'Views' && viewError != '' && <RedError>{viewError}</RedError> }
            </Wrapper>
          ))}
        </Section>
      )}
    </Container>
  );
};

export default EngagementFilter;
